export function handleError(error, toasted, router, store) {
  if (error.response) {
    if (error.response.status === 401) {
      toasted.info("نشست کاربری شما منقضی شده است", {
        duration: 5000,
        keepOnHover: true,
        className: "vazir-font",
        iconPack: "fontawesome",
        icon: "exclamation-circle",
        position: "top-center"
      });
      store.dispatch("logout").finally(() => {
        router.push({ name: "Login" });
      });
    } else if (error.response.status === 403) {
      router.push({ name: "Error403" });
    } else if (error.response.status === 404) {
      router.push({ name: "Error404" });
    } else if (error.response.status === 400) {
      let index = 0;
      let errors = [];
      if (error.response.data.errors) {
        let parentErrors = error.response.data.errors;
        for (let key in parentErrors) {
          let childErrors = parentErrors[key];
          for (let j = 0; j < childErrors.length; j++) {
            errors[index] = childErrors[j];
            index++;
          }
        }
      } else if (error.response.data.message) {
        errors[0] = error.response.data.message;
      } else if (error.response.data) {
        let parentErrors = error.response.data;
        for (let key in parentErrors) {
          let childErrors = parentErrors[key];
          for (let j = 0; j < childErrors.length; j++) {
            errors[index] = key + ": " + childErrors[j];
            index++;
          }
        }
      }
      return errors;
    } else {
      return error;
    }
  } else {
    let errors = [];
    errors[0] = error.message;
    return errors;
  }
}
